import { createGlobalStyle } from 'styled-components';

export const FooterOverride = createGlobalStyle`
    .footer {
        margin-top: 0;
    }
`;
